/**
 * E-mail outcome of one financing-ending bulk-operation item (E7 `emailOutcome`). An item of another
 * bulk action has none.
 */
export const FINANCING_ENDING_EMAIL_OUTCOME = {
  CREATED: 'CREATED',
  SENT: 'SENT',
  FAILED: 'FAILED',
  BLOCKED: 'BLOCKED',
  PENDING: 'PENDING',
} as const;
